import React from "react";

const Select = ({
	id,
	label,
	options,
	placeholder,
	noLabel,
	noPlaceholder,
	register,
	validationSchema,
	...inputProps
}) => {
	return (
		<>
			{!noLabel && (
				<label
					htmlFor={id}
					className="block mb-2 text-sm font-medium text-gray-900 mt-2">
					{label}
				</label>
			)}
			<select
				className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 mr-2"
				id={id}
				{...register(id, validationSchema)}
				{...inputProps}>
				{!noPlaceholder && (
					<option key="intial0intial0" value="">
						{placeholder}
					</option>
				)}
				{options.map((item) => {
					return (
						<option key={item.value} value={item.value}>
							{item.text}
						</option>
					);
				})}
			</select>
		</>
	);
};

export default Select;
